<template>

    <label class="label" :for="labelKey">
        <lang :labelKey="labelKey"></lang>
        <template v-if="tipp">
            <tooltip slot="icon" :content="tipp">
                <span class="icon is-small"><i class="fa fa-question-circle-o"></i></span>
            </tooltip>
        </template>
    </label>

</template>


<script>
export default {
    props: {
        name: {
            type: String,
            default: ''
        },
        labelKey: {
            type: String,
            default: ''
        },
        tipp: {
            type: String,
            default: false
        }
    }

}
</script>
